import * as React from 'react';
import {
  TableRow,
  TableCell,
  IconButton,
  Typography,
  makeStyles,
  Theme,
} from '@bb-ui/react-library';
import { ChevronRight } from '@bb-ui/icons/dist/small/ChevronRight';
import { LearnInstance } from '@bb-learn-instances-service/common';
import { Tooltip } from '@bb-ui/react-library/dist/components/Tooltip';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const LooseIconButton = IconButton as any;

const useStyles = makeStyles((theme: Theme) => ({
  statusLink: {
    color: theme.palette.primary.main,
    textDecoration: 'none',
    fontWeight: 500,
    '&:hover': {
      textDecoration: 'underline',
      color: theme.palette.primary.dark,
    },
  },
}));

export interface LearnSiteRowProps {
  site: LearnInstance;
  index: number;
  rowClass?: string;
  cellTextClass?: string;
}

export const LearnSiteRow: React.FunctionComponent<LearnSiteRowProps> = ({
  site,
  index,
  rowClass,
  cellTextClass,
}) => {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <TableRow
      aria-rowindex={index + 1}
      data-testid={`site-list-table-row-${index}`}
      className={rowClass}
    >
      <TableCell aria-colindex={1} tabIndex={-1} className={cellTextClass}>
        <Tooltip title={site.Name || '-'}>
          <span>{site.Name || '-'}</span>
        </Tooltip>
      </TableCell>
      <TableCell aria-colindex={2} tabIndex={-1} className={cellTextClass}>
        <Tooltip title={site.ClientName || '-'}>
          <span>{site.ClientName || '-'}</span>
        </Tooltip>
      </TableCell>
      <TableCell aria-colindex={3} tabIndex={-1} className={cellTextClass}>
        <Tooltip title={site.InstallationId}>
          <span>{site.InstallationId}</span>
        </Tooltip>
      </TableCell>
      <TableCell aria-colindex={4} tabIndex={-1} className={cellTextClass}>
        <Tooltip title={site.Status}>
          <span>{site.Status}</span>
        </Tooltip>
      </TableCell>
      <TableCell aria-colindex={5} tabIndex={-1} className={cellTextClass}>
        <Tooltip title={site.FleetId || '-'}>
          <span>{site.FleetId || '-'}</span>
        </Tooltip>
      </TableCell>
      <TableCell aria-colindex={6} tabIndex={-1} className={cellTextClass}>
        {site.Url ? (
          <a
            href={/^https?:\/\//i.test(site.Url) ? site.Url : `https://${site.Url}`}
            target="_blank"
            rel="noopener noreferrer"
            className={classes.statusLink}
            onClick={(e) => e.stopPropagation()}
          >
            {site.Url}
          </a>
        ) : (
          '-'
        )}
      </TableCell>
      <TableCell aria-colindex={7} tabIndex={-1} align="right">
        <LooseIconButton
          aria-label="View more information"
          component={Link}
          to={`/learn-site/${site.LearnSiteTenantId}/information`}
        >
          <Typography component="span" variant="inherit">
            {t('global.view')}
          </Typography>
          <ChevronRight />
        </LooseIconButton>
      </TableCell>
    </TableRow>
  );
};

export default LearnSiteRow;
